<template>
  <div class="run-point">
    <div style="margin-bottom:0.8rem">
      <el-button @click="addRun" size="small" type="success" icon="el-icon-plus">添加提示</el-button>
    </div>
    <div v-for="(msg,index) in saveRun" :key="index" class="save-box">
      <div class="run-point-input">
        <span class="trend-title">设备运行提示数据</span>
        <el-select v-model="valueType" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-button @click="removeRun(msg.id,index)" size="small" type="danger" icon="el-icon-minus">删除</el-button>
      </div>
      <div class="run-point-input">
        <span class="trend-title">提示时间</span>
        <el-date-picker
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="msg.eventTime"
          type="datetime"
          placeholder="选择日期时间">
        </el-date-picker>
      </div>
      <div class="run-point-input">
        <span class="trend-title">事件类型</span>
        <el-select v-model="msg.eventCase" placeholder="请选择">
          <el-option
            v-for="item in thingType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="run-point-input">
        <span class="trend-title">事件主体</span>
        <el-input type="text" placeholder="请输入" v-model="msg.eventBody"></el-input>
      </div>
      <div class="run-point-input">
        <span class="trend-title">发生区域</span>
        <el-input type="text" placeholder="请输入" v-model="msg.eventArea"></el-input>
      </div>
      <div class="run-point-input">
        <span class="trend-title">事件内容</span>
        <el-input type="text" placeholder="请输入" v-model="msg.content"></el-input>
        
      </div>
    </div>
    <div class="last-save">
      <el-button :loading="pointLoading" size="small" @click="savePoint" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/apis/device/device'
export default {
  data(){
    return{
      pointLoading:false,//加载状态
      options: [{
        value: 0,
        label: '从后台获取'
      }, {
        value: 1,
        label: '手工录入'
      }],
      thingType: [
        {
          value: '1',
          label: '安全提示'
        }, 
        {
          value: '2',
          label: '管理提示'
        },
        {
          value: '3',
          label: '能耗突增'
        },
        {
          value: '4',
          label: '能耗超标'
        },
      ],
      valueType:1,//事件类型

      saveRun:[
        {eventTime:'',eventCase:'',eventBody:'',eventArea:'',content:''}
      ]
    }
  },
  mounted(){
    this.getPoint()

  },
  methods:{
    //保存数据
    savePoint(){
      this.pointLoading = true;
      api.savePrompt(this.saveRun).then(res=>{
        if(res.code==10000){
          this.pointLoading = false;
          this.getPoint()
          this.$message.success('保存成功')
        }else{
          this.$message.error(res.message)
          this.pointLoading = false;
          return;
        }
      })
    },
    //获取数据
    getPoint(){
      api.getPrompt().then(res=>{
        if(res.code==10000){
          if(res.data){
            this.saveRun = res.data
          }
        }
      })
    },
    //删除一行运行提示
    removeRun(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.delPrompt([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getPoint()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.saveRun.splice(index,1)
      }
    },
    //添加一行运行提示
    addRun(){
      this.saveRun.push({eventTime:'',eventCase:'',eventBody:'',eventArea:'',content:''})
    },
  }
}
</script>
<style lang="less" scoped>
.run-point{ padding-top: 10px;
  .run-point-input{ display:inline-flex; width: 48%; flex-direction: row; margin-bottom: 15px; margin-right: 15px;
    .el-input,.el-select{ flex:1;}
  } 
  .run-point-input:nth-child(1){ width: 100%; margin-bottom: 1rem; display: block;
    .trend-title{ width: 9rem;}
  }
  .save-box{ display:inline-block; border: #3570ff solid 1px; position: relative; width: 45%; padding:1rem; margin-right:1rem; margin-bottom: 1rem; }
}
</style>